import { render, staticRenderFns } from "./CCMAllergy.vue?vue&type=template&id=730e77b0"
import script from "./CCMAllergy.vue?vue&type=script&lang=js"
export * from "./CCMAllergy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports